/**
 * Kiosks reducer (`data.kiosks`).
 */
import { Map, fromJS } from "immutable";
import * as CONST from "actions/action_constants";

const kiosks = (state = Map({}), action) => {
  const { list, kioskID, kioskData } = action;
  switch (action.type) {
    case CONST.KIOSKS_FETCH_SUCCESS:
      return state.merge(list);
    case CONST.KIOSK_FETCH_SUCCESS: {
      const existing = state.get(kioskID, Map({}));
      const updated = existing.merge(fromJS(kioskData));
      return state.set(kioskID, updated);
    }
    case CONST.KIOSK_CREATE_SUCCESS: {
      if (!kioskData || !kioskData._id) {
        return state;
      }
      const id = kioskData._id;
      return state.merge(fromJS({ [id]: { ...kioskData } }));
    }
    case CONST.KIOSK_CREATE_REVERT_COPY:
      return state.set("revertCopy", state.get(kioskID));
    case CONST.KIOSK_REVERT_CHANGES: {
      const revertData = state.get("revertCopy").toJS();
      revertData.isSaved = true;
      const revertKioskId = revertData._id;
      return state.set(revertKioskId, fromJS(revertData));
    }
    /*
    On a new publish request, clear publishStatus and any previous
    publish-error fields so PublishManager can detect a fresh error
    from the saga (it watches publishErrorAt for changes). The error
    fields are client-only -- the server never sends them, so the
    KIOSK_FETCH_SUCCESS merge won't overwrite or clear them.
    */
    case CONST.KIOSK_PUBLISH_REQUEST:
      return state
        .setIn([kioskID, "publishStatus"], "")
        .deleteIn([kioskID, "publishErrorAt"])
        .deleteIn([kioskID, "publishErrorMessage"]);
    /*
    Saga reports a publish failure (the publish POST itself rejected
    or never returned a usable response). Stamp the error onto the
    kiosk slice so PublishManager can react in componentDidUpdate.
    */
    case CONST.KIOSK_PUBLISH_ERROR: {
      if (!kioskID) return state;
      return state
        .setIn([kioskID, "publishErrorAt"], new Date().toISOString())
        .setIn([kioskID, "publishErrorMessage"], action.message || "");
    }
    case CONST.LOGOUT_SUCCESS:
      return state.clear();
    case CONST.KIOSK_PROP_CHANGE: {
      const selector = [];
      selector.push(kioskID, action.prop);
      return state
        .setIn(selector, action.value)
        .setIn([kioskID, "isSaved"], false);
    }
    case CONST.KIOSK_DELETE_SUCCESS:
      return state.remove(kioskID);
    default:
      return state;
  }
};

export default kiosks;
